var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBlikStart = function SvgBlikStart(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#B9FFC6",
    d: "M34.586 10.648c4.341-.81 7.46-3.609 6.968-6.251C41.06 1.754 37.142.269 32.8 1.078c-4.34.81-7.46 3.61-6.967 6.252s4.412 4.128 8.753 3.318M15.334 21.51c6.157-3.079 9.628-8.612 7.755-12.359s-8.383-4.29-14.54-1.211C2.393 11.018-1.078 16.55.795 20.298c1.874 3.747 8.383 4.29 14.54 1.211"
  })));
};
export default SvgBlikStart;